import { render } from "./PanelTipsterPedidos.vue?vue&type=template&id=1adcd6f2&scoped=true"
import script from "./PanelTipsterPedidos.vue?vue&type=script&lang=js"
export * from "./PanelTipsterPedidos.vue?vue&type=script&lang=js"

import "./PanelTipsterPedidos.vue?vue&type=style&index=0&id=1adcd6f2&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adcd6f2"]])

export default __exports__